<template>
    <div id="shareInvoiceModal" ref="shareInvoiceModal" class="modal fade" tabindex="-1"
        aria-labelledby="exampleModalLabel" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
        <div class="modal-dialog modal-dialog-centered laptop:!max-w-[60%] largeDesktop:!max-w-[25%]">
            <div class="modal-content">
                <div class="modal-body !p-[25px] flex flex-col gap-[30px]">
                    <div class="flex items-center justify-between">
                        <div class="flex items-center gap-[5px]">
                            <div class="w-[8px] h-[8px] rounded-full bg-[#FE5000]"></div>
                            <div class="w-[35px] h-[8px] rounded-[10px] bg-[#FE5000]"></div>
                            <h1 class="m-0 text-[20px] font-lato font-bold text-[#092E87]">Share Invoice</h1>
                        </div>
                        <button @click="hide()"
                            class="w-[34px] h-[34px] flex items-center justify-center rounded-full p-[5px] bg-[#EFEFEF] laptop:bg-[#fff] hover:laptop:bg-[#EFEFEF]">
                            <img src="../../assets/images/dismiss-orange-icon.svg" alt="Dismiss Icon"
                                class="w-[15px] h-[15px] object-contain">
                        </button>
                    </div>
                    <div class="flex flex-col gap-[20px]">
                        <h6 class="font-semibold text-[16px] font-lato mb-1.5">Share this link with the customer to complete payment.</h6>
                        <div class="relative w-full h-[42px] rounded-lg !border !border-[#ccc] bg-[#EFEFEF80]/50">
                            <input type="text" v-model="shareInputValue" ref="shareinput"
                                class="w-full h-full p-1.5 2xl:p-2.5 !border-0 outline-none !text-[14px] largeDesktop:text-base !text-[#666666] "
                                disabled>
                            <button @click="copyShareLink"
                                class="absolute top-0 -right-[1px] h-full w-[42px] rounded-r-lg flex items-center justify-center bg-[#FE5000]">
                                <img src="../../assets/images/copyImg.png" alt="Share Icon" class="w-6 h-6">
                            </button>
                        </div>
                        <div class="flex flex-col gap-[3px]">
                            <label class="m-0 text-[14px] font-lato font-normal text-[#666666]">Phone Number</label>
                            <input v-model="phone" name="phone" type="tel" placeholder="Enter Phone Number"
                                class="p-[10px] text-[14px] rounded-[5px] border-[1px] border-[#efefef] outline-none w-full h-full"
                                @input="acceptNumber" @blur="validatePhone" />
                            <p v-if="phoneError" class="m-0 text-red-500 text-[12px]">
                                {{ phoneError }}
                            </p>
                        </div>
                        <div class="flex flex-col gap-[3px]">
                            <label class="m-0 text-[14px] font-lato font-normal text-[#666666]">Email</label>
                            <input v-model="email" type="email" placeholder="Enter Email"
                                class="p-[10px] text-[14px] rounded-[5px] border-[1px] border-[#efefef] outline-none w-full h-full"
                                @blur="validateEmail" />
                            <p v-if="emailError" class="m-0 text-red-500 text-[12px]">
                                {{ emailError }}
                            </p>
                        </div>
                        <div class="py-1 2xl:py-2">
                            <label class="flex items-start space-x-3 cursor-pointer">
                                <input type="checkbox" v-model="consentGiven" class="peer hidden" />
                                <div
                                    class="mobile:!min-w-[20px] mobile:!h-[20px] largeDesktop:min-w-[25px] largeDesktop:h-[25px] !m-0 border-[1px] rounded-[5px] flex items-center justify-center transition border-[#ccc] peer-checked:bg-[#fff] peer-checked:border-[#092E87]">
                                    <svg v-if="consentGiven" xmlns="http://www.w3.org/2000/svg"
                                        class="w-4 h-4 largeDesktop:w-5 largeDesktop:h-5 text-[#092E87]" fill="none"
                                        viewBox="0 0 24 24" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="3"
                                            d="M5 13l4 4L19 7" />
                                    </svg>
                                </div>
                                <span
                                    class="text-[13px] largeDesktop:text-[14px] leading-tight font-lato text-[#999999]">
                                    I confirm that I have the customer's consent to receive communications related to this invoice.
                                </span>
                            </label>
                        </div>
                        <button :disabled="!isValid()" @click="sendSharedURL()" type="button"
                            class="w-max mx-auto px-4 py-1 2xl:px-8 2xl:py-2 text-[14px] 2xl:text-[16px] rounded-full 2xl:rounded-lg !border !border-[#092E87] text-[#092E87] hover:text-white hover:bg-[#092E87] disabled:cursor-not-allowed disabled:!border disabled:!border-[#CCCCCC] disabled:!text-[#CCCCCC] disabled:bg-[#fff]">
                            Send</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Modal } from "bootstrap";
import { mapActions, mapGetters } from "vuex";
import Swal from "sweetalert2";
import { useToast } from "vue-toastification";
const toast = useToast();

export default {
    props: ["invoiceDetail"],

    data() {
        return {
            modal: null,
            loading: true,
            phone: '',
            email: '',
            phoneError: '',
            emailError: '',
            consentGiven: false,
            shareInputValue: '',
            shareLink: false
        };
    },

    computed: {
        ...mapGetters([
            // "paymentLinkResponse",
            // "sendProtectionPlanURLCallBack",


            "invoiceShareUrl",
            "sendInvoiceShareUrl"
        ]),
    },
    watch: {
        invoiceShareUrl: function () {
            if (!this.modal) {
                this.modal = new Modal(this.$refs.shareInvoiceModal, {
                    backdrop: 'static',
                    keyboard: false
                });
                this.shareInputValue = this.invoiceShareUrl
            }
            this?.modal?.show();
        },

        sendInvoiceShareUrl(newValue) {
            if (newValue) {
                toast.success("Invoice URL sent successfully!");
                this.hide();
            }
        }
    },

    mounted() {

    },

    methods: {
        ...mapActions([
            "sendInvoiceUrl",
            "getInvoiceShareUrl"
        ]),

        async show(value) {
            // this.shareInputValue = this.invoiceShareUrl || '';
            this.phone = '';
            this.email = '';
            this.phoneError = '';
            this.emailError = '';
            this.consentGiven = false;
            this.shareLink = false;
            this.getInvoiceShareUrl({
                id: value.id
            })
        },

        hide() {
            this.modal?.hide();
        },

        validatePhone() {
            const regex = /^\(\d{3}\) \d{3}-\d{4}$/;
            const isValid = regex.test(this.phone);
            this.phoneError = isValid ? '' : 'Invalid phone number.';
            return isValid;
        },

        validateEmail() {
            const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            const isValid = regex.test(this.email);
            this.emailError = isValid ? '' : 'Invalid email format.';
            return isValid;
        },

        isValid() {
            const hasEmail = this.email && this.email.trim().length > 0;
            const hasPhone = this.phone && this.phone.trim().length > 0;
            if (!hasEmail && !hasPhone) {
                return false;
            }
            if (hasEmail) {
                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                if (!emailRegex.test(this.email)) {
                    return false;
                }
            }
            if (hasPhone) {
                const phoneRegex = /^\(\d{3}\) \d{3}-\d{4}$/;
                if (!phoneRegex.test(this.phone)) {
                    return false;
                }
            }
            if (!this.consentGiven) {
                return false;
            }
            return true;
        },

        acceptNumber() {
            var x = this.phone
                .replace(/\D/g, "")
                .match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
            this.phone = !x[2] ?
                x[1] :
                "(" + x[1] + ") " + x[2] + (x[3] ? "-" + x[3] : "");
        },

        copyShareLink() {
            if (!this.shareInputValue) return;
            navigator.clipboard.writeText(this.shareInputValue);
            toast.success("Shared URL copied successfully!");
        },

        sendSharedURL() {
            const hasEmail = this.email && this.email.trim().length > 0;
            const hasPhone = this.phone && this.phone.trim().length > 0;
            let phoneValid = true;
            let emailValid = true;
            if (hasPhone) {
                phoneValid = /^\(\d{3}\) \d{3}-\d{4}$/.test(this.phone);
                this.phoneError = phoneValid ? '' : 'Invalid phone number.';
            } else {
                this.phoneError = '';
            }
            if (hasEmail) {
                emailValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.email);
                this.emailError = emailValid ? '' : 'Invalid email format.';
            } else {
                this.emailError = '';
            }
            if (!hasEmail && !hasPhone) {
                this.emailError = 'Please enter either a phone number or email address.';
                return;
            }
            if (!phoneValid || !emailValid) {
                return;
            }
            if (!this.consentGiven) {
                return;
            }
            const payload = {
                phone: this.phone,
                email: this.email,
                url: this.shareInputValue
            };
            this.sendInvoiceUrl(payload);
        }
    }
}
</script>